export default __webpack_public_path__ + "static/media/Pink-Cake-2.6d620c9f.jpg";